module.exports = __webpack_public_path__ + "img/logo.0ee80785.svg";